export default __webpack_public_path__ + "static/media/property-template.64966b40.png";